$(document).ready(function () {
    var $scrollers = $('.js-hero-logos-scroller');

    if (!$scrollers.length) {
        return;
    }

    // Below 1100px the service hero's client logos row swipes sideways
    // (native overflow-x: auto on the list). Flags the wrapper while
    // there are more logos off to the right, which shows a fade "shadow"
    // over its right edge (see .service-hero__logo-scroller in
    // _service-hero-screenshot.scss) - gone once scrolled to the end, or
    // when everything fits (including 1100px+, where the list isn't a
    // scroll box at all).
    function update(scroller) {
        var list = scroller.querySelector('.service-hero__logo-list');

        if (!list) {
            return;
        }

        var hasMore = list.scrollWidth - list.clientWidth - list.scrollLeft > 1;
        scroller.classList.toggle('is-cut-off', hasMore);
    }

    $scrollers.each(function () {
        var scroller = this;
        var list = scroller.querySelector('.service-hero__logo-list');

        update(scroller);

        if (list) {
            list.addEventListener('scroll', function () {
                update(scroller);
            }, { passive: true });
        }

        // Logos are lazy images - re-check as each one loads and changes
        // the list's width.
        $(scroller).find('img').on('load', function () {
            update(scroller);
        });
    });

    $(window).on('resize', function () {
        $scrollers.each(function () {
            update(this);
        });
    });
});
